import React from 'react';
import Box from '@Atoms/Box';

interface ScoreBarProps {
  percentage: number;
  color?: string;
  height?: number;
}

const ScoreBar: React.FC<ScoreBarProps> = ({
  percentage,
  color = 'success.main',
  height = 20,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Box
      sx={{
        width: '100%',
        bgcolor: 'action.hover',
        borderRadius: 0.5,
        height,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          bgcolor: color,
          height,
          borderRadius: 0.5,
          transition: 'all 0.3s',
          width: `${percentage}%`,
        }}
      />
    </Box>
    <Box
      component="span"
      sx={{
        fontSize: '0.75rem',
        fontWeight: 500,
        color: 'text.primary',
        minWidth: 'fit-content',
      }}
    >
      {percentage.toFixed(0)}%
    </Box>
  </Box>
);

export default ScoreBar;
